var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-restricted-imports */
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { formatDateTime } from '@juvare/common-web-ui/utils';
import { requireAnyOrgPermission, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useDocumentLibraryStorage } from '@juvare/document-library/ui/hooks';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { useFunctionClient } from '@juvare/platform-sdk-react/ui/hooks';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { parseISO } from 'date-fns';
import React from 'react';
import { archiveAlertsBulkActionType } from '../../../../../../backend/features/alerts/bulk-actions';
import { useAlertUiTranslation, useReportClient } from '../../../../../hooks';
import { downloadBlob } from '../../../utils';
export const AlertActionsSent = ({ data: alertData, onReload, onCloseDialog }) => {
    const { t } = useAlertUiTranslation();
    const storage = useDocumentLibraryStorage();
    const reportClient = useReportClient();
    const userState = useUserState();
    const functionClient = useFunctionClient();
    const handleSaveReport = (reportType) => {
        var _a;
        const saveToOptions = [{ label: t('common.saveToComputer'), value: 'computer' }];
        const alertDateTime = formatDateTime(parseISO((_a = alertData.sendDateTime) !== null && _a !== void 0 ? _a : alertData.updated));
        if (requireAnySystemPermission(userState, 'manage-documents') || requireAnyOrgPermission(userState, 'manage-documents')) {
            saveToOptions.push({
                label: t('common.saveToFileLibrary'),
                value: 'fileLibrary',
            });
        }
        showFormDialog({
            title: reportType === 'summaryPdf' ? t('common.saveNotificationSummaryPdf') : t('common.saveDeliveryAndResponseCSV'),
            onSubmit: (formData) => __awaiter(void 0, void 0, void 0, function* () {
                let reportName;
                if (reportType === 'summaryPdf') {
                    reportName = `${alertDateTime} ${alertData.subject} ${alertData.ownerName} ${alertData.sentBy || ''} Notification Summary.pdf`;
                }
                else {
                    reportName = `${alertDateTime} ${alertData.subject} ${alertData.ownerName} ${alertData.sentBy || ''} Delivery and Response.csv`;
                }
                try {
                    if (formData.saveTo === 'computer') {
                        if (reportType === 'summaryPdf') {
                            const blob = yield reportClient.getAlertStatisticsPdfReport(alertData.id, Intl.DateTimeFormat().resolvedOptions().timeZone);
                            downloadBlob(blob, reportName);
                        }
                        else {
                            const blob = yield reportClient.getAlertResponsesCsvReport(alertData.id, Intl.DateTimeFormat().resolvedOptions().timeZone);
                            downloadBlob(blob, reportName);
                        }
                    }
                    else if (formData.saveTo === 'fileLibrary') {
                        const directoryName = `${alertDateTime} ${alertData.subject}`;
                        const response = yield functionClient.executeFunction({
                            functionName: 'getOrCreateReportDirectory',
                            params: { directoryName: directoryName },
                        });
                        let blob;
                        if (reportType === 'summaryPdf') {
                            blob = yield reportClient.getAlertStatisticsPdfReport(alertData.id, Intl.DateTimeFormat().resolvedOptions().timeZone);
                        }
                        else {
                            blob = yield reportClient.getAlertResponsesCsvReport(alertData.id, Intl.DateTimeFormat().resolvedOptions().timeZone);
                        }
                        const existsResponse = yield storage.isFileExists({
                            name: reportName,
                            parentId: response.result.directoryId,
                        });
                        // if file exists update it
                        if (existsResponse.exists) {
                            yield storage.fileStorageClient.post({
                                action: 'partial-update',
                                data: {
                                    checkOutUserId: userState.id,
                                },
                                id: existsResponse.fileId,
                            });
                            yield storage.checkIn({
                                fileId: existsResponse.fileId,
                                content: blob,
                                contentLength: blob.size,
                                contentType: blob.type,
                            });
                        }
                        else {
                            yield storage.createFile({
                                name: reportName,
                                ownerId: userState.id,
                                content: blob,
                                contentLength: blob.size,
                                contentType: blob.type,
                                parentId: response.result.directoryId,
                            });
                        }
                        showAlertSnackbar({
                            message: t('common.reportSavedToFileLibrary'),
                            autoHideDuration: 2000,
                            type: 'success',
                        });
                    }
                }
                catch (error) {
                    handleErrorDialog(error);
                }
            }),
            data: {
                saveTo: 'computer',
            },
            config: {
                type: 'form',
                children: [
                    {
                        label: '',
                        type: 'form.advancedRadio',
                        key: 'saveTo',
                        values: saveToOptions,
                    },
                ],
            },
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: t('common.notificationSummaryPdf') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    handleSaveReport('summaryPdf');
                } },
                React.createElement(PictureAsPdfOutlinedIcon, null))),
        React.createElement(Tooltip, { title: t('common.deliveryAndResponseCsv') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    handleSaveReport('deliveryAndResponseCsv');
                } },
                React.createElement(TextSnippetOutlinedIcon, null))),
        React.createElement(Tooltip, { title: t('common.archive') },
            React.createElement("span", null,
                React.createElement(IconButton, { color: 'primary', disabled: alertData.status === 'sending', onClick: () => {
                        showConfirmDialog({
                            title: t('archiveAlertsDialog.title', { count: 1 }),
                            content: t('archiveAlertsDialog.message', { count: 1, page: 'Sent Archived' }),
                            confirmLabel: t('common.archive'),
                            onConfirm: () => {
                                launchBulkAction({
                                    type: archiveAlertsBulkActionType,
                                    title: t('archiveAlertsDialog.progress', { count: 1 }),
                                    runSync: true,
                                    params: { alertIds: [alertData.id] },
                                    onClose: () => {
                                        onReload(true);
                                        onCloseDialog();
                                    },
                                });
                            },
                        });
                    } },
                    React.createElement(ArchiveOutlinedIcon, null))))));
};
